<template>
  <ValidationObserver
    ref="observer"
    class="needs-validation form-custom-format"
    :class="{ 'was-validated': validated }"
    tag="form"
    v-slot="{ passes }"
    @submit.prevent="onSubmitForm"
  >
    <el-dialog
      title="Brand"
      :visible.sync="syncModal"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="600px"
      class="text-left brand-dialog"
      @closed="dialogState(false)"
    >
      <mdb-container class="mt-0 mb-0">
        <ThatsInput
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Brand Code"
          vid="short"
          name="short"
          v-model="form.short"
          :validated="validated"
          :rules="''"
          size="sm"
          :disabled="false"
        />
        <ThatsInput
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Brand Name"
          vid="name"
          name="name"
          v-model="form.name"
          :validated="validated"
          :rules="'required'"
          size="sm"
        />
        <ThatsTextarea
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Description"
          vid="description"
          name="description"
          v-model="form.description"
          :validated="validated"
          :rules="''"
          size="sm"
        />
        <ThatsRadio
          labelClass="col-sm-3"
          fieldClass="col-sm-9 pl-0"
          label="Status"
          vid="status"
          name="status"
          orientation="inline"
          :data="statusOptions"
          v-model="form.status"
          :validated="validated"
          :rules="'required'"
          size="sm"
        />
        <!-- <ThatsCheckbox
          label="Hidden"
          vid="brand-hidden-status"
          orientation="inline"
          name="brand-hidden-status"
          :data="[]"
          v-model="form.hidden"
          :validated="validated"
          :rules="''"
          size="sm"
          :multiple="false"
        /> -->
      </mdb-container>

      <template slot="footer">
        <mdb-btn color="elegant" size="sm" :disabled="formLoading" @click.native="passes(onSubmitForm)">
          <span v-if="formLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ formLoading ? 'Loading...' : 'Save' }}
        </mdb-btn>
        <mdb-btn color="grey" size="sm" @click.native="closeDialog">Close</mdb-btn>
      </template>
    </el-dialog>
  </ValidationObserver>
</template>

<script>
import { mdbBtn, mdbContainer } from 'mdbvue';
import { ValidationObserver } from 'vee-validate';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  ThatsCheckbox,
  ThatsInput,
  ThatsRadio,
  ThatsTextarea
} from '../../components/thats/Thats';

export default {
  components: {
    ValidationObserver,
    ThatsCheckbox,
    ThatsInput,
    ThatsRadio,
    ThatsTextarea,
    mdbBtn,
    mdbContainer
  },

  data() {
    return {
      validated: false,
      form: this.formVar(),
      formLoading: false,
      response: {
        error: null,
        message: null
      },
      statusOptions: [
        { label: 'Active', value: 'true' },
        { label: 'Inactive', value: 'false' }
      ],
      syncModal: false
    };
  },

  methods: {
    ...mapActions('BrandModule', ['StoreRecord', 'UpdateRecord']),
    ...mapMutations('BrandModule', ['SetFormStatusCreate']),

    formVar() {
      return {
        name: null,
        short: null,
        description: null,
        attr: {
          address: null,
          contact_person: null,
          email: null,
          contact_number: null,
          website: null,
          username: null,
          password: null
        },
        logo: [],
        area: [],
        status: 'true',
        hidden: false
      };
    },

    openDialog() {
      this.syncModal = true;
    },

    closeDialog() {
      this.syncModal = false;
    },

    onSubmitForm() {
      if (this.formLoading) {
        return;
      }

      this.validated = true;
      this.formLoading = true;

      const request = this.FormStatus === 'create'
        ? this.StoreRecord(this.form)
        : this.UpdateRecord(this.form);

      request.then((response) => {
        this.$ThatsNotify.success({
          message: this.FormStatus === 'create' ? undefined : 'Record was successfully updated'
        });
        this.$emit('success', response);
        this.closeDialog();
        this.FormResetter();
      }).catch((error) => {
        this.formLoading = false;
        this.response.error = 1;

        if (error.response && error.response.data && error.response.data.errors) {
          this.$refs.observer.setErrors(error.response.data.errors);
        } else if (error.request) {
          this.response.message = error.request;
        } else {
          this.response.message = error.message;
        }
      });
    },

    FormResetter() {
      this.form = this.formVar();
      this.validated = false;
      this.formLoading = false;
      this.SetFormStatusCreate();

      this.$nextTick(() => {
        if (this.$refs.observer) {
          this.$refs.observer.reset();
        }
      });
    },

    normalizeStatus() {
      this.form.status = [true, 1, '1', 'true'].includes(this.form.status)
        ? 'true'
        : 'false';
    },

    dialogState(state) {
      if (!state) {
        this.FormResetter();
      }
    },

    emitDelete() {
      this.$emit('delete', this.FormRecord);
    }
  },

  computed: {
    ...mapGetters('BrandModule', ['FormStatus', 'FormRecord'])
  },

  watch: {
    FormRecord(value) {
      if (this.FormStatus === 'update' && value) {
        this.form = JSON.parse(JSON.stringify(value.row || value));

        if (!this.form.attr) {
          this.form.attr = this.formVar().attr;
        }

        this.normalizeStatus();
      }
    },

    'form.name'(value) {
      if (value !== null) {
        this.form.short = value.substring(0, 4).toUpperCase();
      }
    }
  }
};
</script>
